import { Link, StaticQuery, graphql } from "gatsby"
import { css } from "@emotion/core"
import styled from "@emotion/styled"
import React, {useEffect, useState} from "react"

import { mq, fontSize } from "../mixins"

import "./footer.scss"

const Footer = props => {
  const [isNativeMobile, setIsNativeMobile] = useState(false);

  useEffect(() => {
    const cookies = document.cookie;

    if (/isNativeiOS|isNativeAndroid|isNativeSportsbook/.test(cookies)) {
      setIsNativeMobile(true);
    }
  }, []);

  const footer = css`
    background: #000;
    & > * {
      color: #fff;
    }
  `
  const footerContainer = css`
    display: block;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    /* border: 1px solid red; */
  `

  const FooterTop = styled("div")`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    a {
      position: relative;
      font-family: "Saira Condensed", sans-serif;
      line-height: 1.5;
      text-transform: uppercase;
      ${fontSize(24, 42)}
      &:after {
        content: "";
        position: absolute;
        bottom: 5px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        width: 100%;
        border-bottom: 2px solid #fff;
      }

      &:hover {
        &:after {
          display: none;
        }
      }
    }
    .footer__top__link {
      flex: none;
      width: calc(100% / ${props => props.column});
      max-width: 450px;
      text-align: center;
      padding: 6% 0;
      margin: 11% 0;
      &:nth-of-type(even) {
        border-left: 1px solid #fff;
      }
      ${mq("smTablet")} {
        margin: 3.5% 0;
      }
    }
  `
  const footerBottom = css`
    display: flex;
    flex-direction: column-reverse;
    padding-top: 5px;
    padding-bottom: 65px;
    ${mq("smTablet")} {
      padding-top: 30px;
      padding-bottom: 65px;
      flex-direction: row;
    }
  `

  const footerBottomImg = css`
    width: 100%;
    flex: none;
    img {
      width: 100%;
      max-width: 190px;
      margin-left: 9%;
      margin-top: 13%;
    }
    ${mq("smTablet")} {
      width: 50%;
      img {
        margin-top: 0%;
        margin-left: 20%;
      }
    }
  `

  const footerBottomLinks = css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: none;
    width: calc(50% - 9%);
    margin-left: 9%;
    a {
      font-family: "Open Sans", sans-serif;
      font-weight: 400;
      line-height: 1.7;
      font-size: 14px;
      padding: 5px 0;

      &:hover {
        text-decoration: underline;
      }
    }
    ${mq("smTablet")} {
      margin-left: 8%;
      flex-direction: row;
    }
  `

  const footerBottomLinksLeft = css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    ${mq("smTablet")} {
      width: 50%;
      flex: none;
      padding-right: 20px;
    }
  `

  const footerBottomLinksRight = css`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 32px;
    ${mq("smTablet")} {
      width: 50%;
      flex: none;
      flex-wrap: wrap;
      max-height: 195px;
      padding-top: 0;
    }
  `
  return isNativeMobile ? null : (
    <footer className="footer" css={footer}>
      <div className="footer__container" css={footerContainer}>
        <FooterTop
          className="footer__top"
          column={
            props.data.contentstackFooter.reference.find(
              x => x["__typename"] === "Contentstack_footer_top_links"
            ).modular_blocks.length
          }
        >
          {props.data.contentstackFooter.reference
            .find(x => x["__typename"] === "Contentstack_footer_top_links")
            .modular_blocks.map((block, key) => {
              if (block.footer_top_links_block.link_type === "internal") {
                return (
                  <div className="footer__top__link" key={key}>
                    <Link to={block.footer_top_links_block.link.href}>
                      {block.footer_top_links_block.link.title}
                    </Link>
                  </div>
                )
              } else {
                return (
                  <div className="footer__top__link" key={key}>
                    <a
                      href={block.footer_top_links_block.link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {block.footer_top_links_block.link.title}
                    </a>
                  </div>
                )
              }
            })}
        </FooterTop>
        <div className="footer__bottom" css={footerBottom}>
          <div className="footer__bottom__img" css={footerBottomImg}>
            <img
              src={
                props.data.contentstackDraftkingsLogos.draftkings_linear_logo
                  .url
              }
              alt="Draftkings Logo"
            />
          </div>
          <div className="footer__bottom__links" css={footerBottomLinks}>
            <div
              className="footer__bottom__link--left"
              css={footerBottomLinksLeft}
            >
              {props.data.contentstackFooter.reference
                .find(x => x["__typename"] === "Contentstack_footer_links")
                .modular_blocks.map((block, key) => {
                  if (block.footer_link_block.link_type === "internal") {
                    return (
                      <Link to={block.footer_link_block.link.href} key={key}>
                        {block.footer_link_block.link.title}
                      </Link>
                    )
                  } else {
                    return (
                      <a
                        href={block.footer_link_block.link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={key}
                      >
                        {block.footer_link_block.link.title}
                      </a>
                    )
                  }
                })}
            </div>
            <div
              className="footer__bottom__link--right"
              css={footerBottomLinksRight}
            >
              {props.data.contentstackFooter.reference
                .find(
                  x => x["__typename"] === "Contentstack_footer_social_links"
                )
                .modular_blocks.map((block, key) => {
                  if (block.footer_social_block.link_type === "internal") {
                    return (
                      <Link to={block.footer_social_block.link.href} key={key}>
                        {block.footer_social_block.link.title}
                      </Link>
                    )
                  } else {
                    return (
                      <a
                        href={block.footer_social_block.link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={key}
                      >
                        {block.footer_social_block.link.title}
                      </a>
                    )
                  }
                })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        contentstackFooter {
          reference {
            __typename
            ... on Contentstack_footer_links {
              modular_blocks {
                footer_link_block {
                  link {
                    href
                    title
                  }
                  link_type
                }
              }
            }
            ... on Contentstack_footer_social_links {
              modular_blocks {
                footer_social_block {
                  link {
                    href
                    title
                  }
                  link_type
                }
              }
            }
            ... on Contentstack_footer_top_links {
              modular_blocks {
                footer_top_links_block {
                  link_type
                  link {
                    href
                    title
                  }
                }
              }
            }
          }
        }
        contentstackDraftkingsLogos {
          draftkings_linear_logo {
            title
            url
            internal {
              description
            }
          }
        }
      }
    `}
    render={data => <Footer data={data} {...props} />}
  />
)
